import { useTranslation } from 'react-i18next'
import { Button, CloseIcon, H2 } from '@/components/atoms'
import { Text } from '@/components'
import { LogoKanguroOrange, goodDog } from '@/shared/assets'
import { type AppVersionPayload } from '@/shared/hooks/use-app-version-flag'
import { useAppUpdateScreen } from './app-update-screen.hook'

interface AppUpdateScreenProps {
  payload?: AppVersionPayload
  onDismiss?: () => void
}

export function AppUpdateScreen({ payload, onDismiss }: AppUpdateScreenProps) {
  const { t } = useTranslation()
  const { title, description, storeUrl } = useAppUpdateScreen(payload)

  return (
    <div
      className={`relative flex h-full flex-col justify-between gap-6 bg-white px-6 ${!onDismiss ? 'pt-[calc(1rem+var(--sat))] pb-6' : 'pt-0'}`}
    >
      {onDismiss && (
        <Button
          onClick={onDismiss}
          variant="link"
          className="absolute top-0 right-8 z-50 ml-auto rounded-full text-indigo-900"
          aria-label="Close"
        >
          <CloseIcon className="h-5 w-5" />
        </Button>
      )}
      <div className="flex justify-center gap-6">
        <img src={LogoKanguroOrange} alt="Kanguro" className="h-10" />
      </div>

      <div className="flex flex-col items-center justify-center gap-6 text-center">
        <div className="relative flex items-center justify-center">
          <div className="h-56 w-56 rounded-full bg-(--update-screen-bg)" />
          <img
            src={goodDog}
            alt=""
            aria-hidden="true"
            className="absolute h-52 w-52 object-contain"
          />
        </div>

        <div className="flex flex-col gap-6">
          <H2 className="text-2xl font-bold text-indigo-900">{title}</H2>
          <Text className="text-base text-neutral-600">{description}</Text>
        </div>
      </div>

      <div className="flex flex-col gap-3">
        <Button onClick={() => window.open(storeUrl, '_blank')}>
          {t('appVersion.cta')}
        </Button>
        {onDismiss && (
          <Button variant="secondary" onClick={onDismiss}>
            {t('appVersion.dismiss')}
          </Button>
        )}
      </div>
    </div>
  )
}
